export default "__VITE_ASSET__4e6d67e3__"